import { ReactNode } from 'react';

import { DecisionFieldMark } from 'DecisionPackage/MainModule/components/DecisionFieldMark';
import { ErknmFieldMark } from 'KnmErknmPackage/MainModule/components/ErknmFieldMark';
import { PmFieldMark } from 'KnmPmPackage/MainModule/components/PmFieldMark';

interface IProps {
  label: string;
  field?: string;
  sectionName?: string;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  additionContent?: ReactNode | JSX.Element | boolean;
}

export function getTitleFieldWithRedStar({
  field,
  sectionName,
  label,
  isDecision,
  isKnm,
  isPm,
  additionContent,
}: IProps) {
  const label_parts = label.split(' ');
  const label_last_word = label_parts.pop();

  return (
    <>
      <span style={{ whiteSpace: 'pre-line' }}>
        {label_parts.join(' ')}{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          {label_last_word} {isKnm && <ErknmFieldMark sectionName={sectionName} fieldName={field} />}
          {isPm && <PmFieldMark sectionName={sectionName} fieldName={field} />}
          {isDecision && <DecisionFieldMark sectionName={sectionName} fieldName={field} />}
        </span>
      </span>

      {additionContent}
    </>
  );
}
